import { formatPrice } from '~/common/utils/numberUtil';
import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';

interface ComparisonPriceProps {
  className?: string;
  hasComparisonPrice?: boolean;
  comparisonPrice?: number;
  comparisonPriceUnitText?: string;
}

const ArticleComparisonPrice = ({
  className,
  hasComparisonPrice,
  comparisonPriceUnitText,
  comparisonPrice
}: ComparisonPriceProps) => {
  const { i18n } = useTranslation();

  if (!hasComparisonPrice) {
    return null;
  }

  return (
    <div className={cn('justify-around', className)}>
      <div>{`${formatPrice(comparisonPrice ?? 0, i18n.language, 2)} / ${comparisonPriceUnitText}`}</div>
    </div>
  );
};

export default ArticleComparisonPrice;
